import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import LayoutInner from '../../../../layouts/main/components/layout-inner/layout-inner';
import CustomButton from '../../../../shared/components/buttons/custom-button/custom-button';
import { PlusIcon } from '../../../../shared/icons/plus-icon';
import { useAppDispatch } from '../../../../store/hooks';
import AuthGuard from '../../../auth/components/auth-guard/auth-guard';
import { openModal } from '../../../ui/store/ui-slice';
import { UserPermissionType } from '../../../user/models/user-permission-type';
import ClientUsersContent from '../../components/client-users-content/client-users-content';
import { clientUserFormModalId } from '../../constants/constants';

export const clientUsersAlertId = 'clientUsersAlert';

const ClientUsers = (): JSX.Element => {
  const { t } = useTranslation(['client-users', 'common']);
  const dispatch = useAppDispatch();

  return (
    <AuthGuard permission={UserPermissionType.ViewUsers}>
      <Helmet>
        <title>{t('menu.clientUsers', { ns: 'common' })}</title>
      </Helmet>
      <LayoutInner
        alertId={clientUsersAlertId}
        headerActionButton={
          <CustomButton
            type="primaryLight"
            onClick={() => dispatch(openModal(clientUserFormModalId))}
            icon={<PlusIcon />}
          >
            {t('newUser')}
          </CustomButton>
        }
      >
        <ClientUsersContent />
      </LayoutInner>
    </AuthGuard>
  );
};

export default ClientUsers;
